import "./styles.css";

export default function Button({ text, onClick = () => {} }) {
  return (
    <div tabIndex={0} className="buttonContainer" onClick={() => onClick()}>
      {text}
    </div>
  );
}
